import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.Toolbar', {
    addUserButtonText: 'Add New Users',
    searchPlaceholder: 'Search...',
    bulkInvitedUsersText: 'Invite',
});
